import { Cpu, X } from "react-feather";
import Button from "../../input/Button";
import { ResizableScrollingTextRenderer } from "../../renderer/StyleRenderer";
import Grid from "../../Grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const JobConfirmationAlert = ({ alerts, closeModal2 }) => {
  const navigate = useNavigate();
  console.log("alerts", alerts);
  const [gridData, setGridData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  function getDelayInDays(dateValue) {
    console.log("dateValue", dateValue);
    if (!dateValue) return "0 days";

    const today = new Date();
    const date = new Date(dateValue);

    // remove time part
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const diff = today.getTime() - date.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    return `${days} day${days === 1 ? "" : "s"}`;
  }

  useEffect(() => {
    setIsLoading(true);
    let data = [];
    if (alerts) {
      alerts.forEach((element) => {
        console.log("element", element);
        data.push({
          ...element.nceInfo,
          delay: getDelayInDays(element.nceInfo.opeConfirmedDate),
        });
      });
      setGridData(data);
    }

    setIsLoading(false);
  }, [alerts]);

  const processJobs = () => {
    if (!gridData?.length) return;

    const jobIds = gridData.map((item) => item.jobId).join(",");

    navigate(
      `/transaction/job-monitoring?id=${encodeURIComponent(jobIds)}&type=jobConfirmationAlert`,
    );

    closeModal2(false);
  };
  return (
    <div style={{ padding: "8px" }}>
      <Grid
        heading="Job Confirmation Alerts"
        isLoading={isLoading}
        content={gridData}
        config={[
          {
            headerName: "Job",
            field: "jobCode",
          },
          { headerName: "Request", field: "reqCode" },
          { headerName: "Operation Confirmed Date", field: "opeConfirmedDate" },
          { headerName: "Delay", field: "delay" },
          {
            headerName: "Message",
            field: "message",
            cellRenderer: ResizableScrollingTextRenderer,
          },
        ]}
        //   onCellDoubleClicked={async (props) => {
        //     setSearchFetchLoading(true);
        //     const response = await stakeholderById(props.data.stkId);
        //     setEditStakeholder(response);
        //     setEditMode(true);
        //     setIsDrawerOpen(true);
        //     setSearchFetchLoading(false);
        //   }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          paddingTop: "5px",
          paddingBottom: "5px",
          gap: "5px",
        }}
      >
        <Button Icon={X} label={"Close"} onClick={closeModal2} color="red" />
        <Button
          Icon={Cpu}
          label={"Process Jobs"}
          onClick={processJobs}
          color="black"
        />
      </div>
    </div>
  );
};

export default JobConfirmationAlert;
